export default "__VITE_ASSET__BEh6Yh_R__"